import Meta from "./Meta";
import { signIn, useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { BRAND_IMG } from "@/constants";

const Login = () => {
  const [callbackURL, setCallbackURL] = useState<string>();
  const { status } = useSession();
  const router = useRouter();

  useEffect(() => {
    status === "authenticated"
      ? router.push("/power-app-transactions?page=1")
      : setCallbackURL(
          decodeURIComponent(
            router.query.callbackUrl ||
              `${window.location.origin}/power-app-transactions?page=1`
          )
        );
  }, [router, status]);

  return (
    <>
      <Meta title="Login" />
      <div className="wrapper wrapper--no-sidebar">
        <div className="vh-100 bg-light d-flex justify-content-center align-items-center">
          <div>
            <div>
              <div>
                <div className="text-center">
                  <img
                    src={BRAND_IMG}
                    alt="logo"
                    width={50}
                    height={50}
                    className="mix-blend"
                  />
                </div>

                <div className="p-4 bg-white shadow mt-3 text-center rounded-lg">
                  <p className="mt-2">Login to your account to continue.</p>

                  <span
                    onPointerDown={() =>
                      signIn(
                        "azure-ad",
                        {
                          callbackUrl: callbackURL,
                        },
                        {
                          prompt: "login",
                        }
                      )
                    }
                    className="btn-dark btn text-white text-white rounded mb-3"
                  >
                    <span className="mr-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 19 19"
                      >
                        <rect className="a-microsoft" width="9" height="9" />
                        <rect
                          className="b-microsoft"
                          width="9"
                          height="9"
                          transform="translate(0 10)"
                        />
                        <rect
                          className="c-microsoft"
                          width="9"
                          height="9"
                          transform="translate(10)"
                        />
                        <rect
                          className="d-microsoft"
                          width="9"
                          height="9"
                          transform="translate(10 10)"
                        />
                      </svg>
                    </span>
                    <span>Sign in with Microsoft</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
